import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const multiplanTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#27644e',
    },
    secondary: {
      main: '#c9a46f',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#27644e',
    },
  },
};
